export default __webpack_public_path__ + "static/media/CV_Berarma_Oussama.6a54d532.pdf";